import { Component, Input, OnInit } from '@angular/core';
import { miscellaneous } from '@app/consts';

@Component({
  selector: 'app-employee-image',
  templateUrl: './employee-image.component.html',
  styleUrls: ['./employee-image.component.scss']
})
export class EmployeeImageComponent implements OnInit {
  public miscellaneous: typeof miscellaneous = miscellaneous;
  @Input() profilePhoto: string | null = null;
  @Input() employeeId: string | null = null;

  @Input() alt: string = '';
  @Input() width: number;
  @Input() height: number;
  @Input() round: boolean = false;

  constructor(
  ) { }

  ngOnInit(): void {}

}
